import { render, staticRenderFns } from "./launch-footer.vue?vue&type=template&id=745fa1be&"
import script from "./launch-footer.vue?vue&type=script&lang=ts&"
export * from "./launch-footer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports